import React, { useEffect, useState } from "react";

import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import CommitOutlinedIcon from "@mui/icons-material/CommitOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import InsertChartOutlinedOutlinedIcon from "@mui/icons-material/InsertChartOutlinedOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { Box, Divider, Grid, Link, Stack } from "@mui/material";

import { Meta } from "../../services/api/";
import { METRICS_URL } from "../../services/api/Resolver";
import MenuLink, { LinkItem } from "../shared/LinkMenu";

const Footer: React.FC<{ suppliedMeta?: Meta | undefined }> = ({ suppliedMeta }) => {
  const [meta, setMeta] = useState<Meta | undefined>(suppliedMeta);
  useEffect(() => {
    if (!suppliedMeta) {
      Meta.retrieve().then(setMeta);
    }
  }, [suppliedMeta]);

  const getFooterLinks = (metaResponse: Meta) => {
    const backendRepoLink = "https://github.com/NBCUDTC/peacock-ad-transcode-pipeline-src";
    const frontendRepoLink = "https://github.com/NBCUDTC/peacock-ad-transcode-pipeline-ui";

    const tagLinks: LinkItem[] = [
      {
        label: `Backend: ${metaResponse.name}.${metaResponse.version}`,
        href: `${backendRepoLink}/releases/tag/${metaResponse.version}`,
      },
      {
        label: `Frontend: ${process.env.REACT_APP_COMMIT_TAG}`,
        href: `${frontendRepoLink}/releases/tag/${process.env.REACT_APP_COMMIT_TAG}`,
      },
    ];

    const commitHashLinks: LinkItem[] = [
      {
        label: `Backend: ${metaResponse.git_commit}`,
        href: `${backendRepoLink}/commit/${metaResponse.git_commit}`,
      },
      {
        label: `Frontend: ${process.env.REACT_APP_COMMIT_HASH}`,
        href: `${frontendRepoLink}/commit/${process.env.REACT_APP_COMMIT_HASH}`,
      },
    ];

    return (
      <Grid sx={{ paddingLeft: "20px" }} container spacing={2}>
        <Grid item sx={{ textAlign: "left", padding: "20px" }} md={7} sm={12}>
          <Stack direction="row" spacing={2} alignItems="center">
            <MenuLink label={"tags"} icon={<LocalOfferOutlinedIcon />} links={tagLinks} />
            <MenuLink label={"commits"} icon={<CommitOutlinedIcon />} links={commitHashLinks} />
          </Stack>
        </Grid>
        <Grid item sx={{ textAlign: "right", padding: "20px" }} md={5} sm={12}>
          <Stack direction="row" spacing={3} alignItems="center" justifyContent="flex-end">
            <Box>
              <DescriptionOutlinedIcon sx={{ verticalAlign: "middle" }} />
              <Link
                target="_blank"
                sx={{ color: "inherit" }}
                underline="hover"
                href={
                  "https://gspcloud.atlassian.net/wiki/spaces/Playback/pages/69772615/Ad+Transcode+Pipeline+ATP"
                }
              >
                Documentation
              </Link>
            </Box>
            <Box>
              <InsertChartOutlinedOutlinedIcon sx={{ verticalAlign: "middle" }} />
              <Link target="_blank" sx={{ color: "inherit" }} underline="hover" href={METRICS_URL}>
                Metrics
              </Link>
            </Box>
            <Box>
              <BugReportOutlinedIcon sx={{ verticalAlign: "middle" }} />
              <Link
                target="_blank"
                sx={{ color: "inherit" }}
                underline="hover"
                href={"mailto:atp.midnight.support@nbcuni.com?subject=ATP Bug Report"}
              >
                Bug report
              </Link>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    );
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: -15,
        width: "100%",
        bgcolor: "background.default",
        fontSize: "13px",
        color: "gray",
      }}
      component={"footer"}
    >
      <Divider sx={{ marginBottom: "6px" }} />
      {meta !== undefined && getFooterLinks(meta)}
    </Box>
  );
};

export const footerPaddingBottom = "calc(16vh - 4vw)";
export default Footer;
